import { render, staticRenderFns } from "./FaceMergeForm.vue?vue&type=template&id=0b556b72&scoped=true"
import script from "./FaceMergeForm.vue?vue&type=script&lang=js"
export * from "./FaceMergeForm.vue?vue&type=script&lang=js"
import style0 from "./FaceMergeForm.vue?vue&type=style&index=0&id=0b556b72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b556b72",
  null
  
)

export default component.exports